import { minimize_str } from "@core/helpers/string";

// the form builder's submit (web-server createFormSubmission): the server checks login, captcha, throttle, version and
// every value again; `duplicate: true` means the same answer was already received (it is a success for the visitor)
// the step a logged-in visitor has reached in a form that keeps drafts, with what was filled so far (web-server saveFormProgress)
export const SAVE_FORM_PROGRESS = minimize_str(`
  mutation ($input: SaveFormProgressInput!) {
   result: saveFormProgress(input: $input) {
    success
    step
    id
   }
  }
`);

// "cancel the request": the visitor's own draft gets the status deleted (web-server cancelFormSubmission)
export const CANCEL_FORM_SUBMISSION = minimize_str(`
  mutation ($input: CancelFormSubmissionInput!) {
   result: cancelFormSubmission(input: $input) {
    success
    id
    status
   }
  }
`);

export const CREATE_FORM_SUBMISSION = minimize_str(`
  mutation ($input: CreateFormSubmissionInput!) {
   result: createFormSubmission(input: $input) {
    success
    duplicate
    id
   }
  }
`);
